import React from "react";
import { ProductView } from "./ProductView";
import {
  CrudlStatus,
  ToggleState,
  PageState
} from "../../common/config/AppConstants";
import { ViewState } from "../../common/config/AppConstants";
import { ValidateState } from "../../common/config/AppConstants";
import * as pr from "../../common/PrimeComponents";
import * as format from "../../common/FormatFunctions";

import { LoadScreen } from "../Common/LoadScreen";
import { ErrorScreen } from "../Common/ErrorScreen";

export class ProductController extends React.Component {
  state = {
    pageName: "ProductController",
    pageState: PageState.IDLE,
    editLoading: true,

    //DISPLAY STATES
    viewState: ViewState.TABLE,

    validateState: ValidateState.NONE,
    crudlState: CrudlStatus.LIST,
    menuState: [],

    // DATA TABLE
    expandedRows: null,
    tableColumns: [],
    columnOptions: [],
    rowCount: 10,
    settingsToggle: ToggleState.OFF,

    // DETAILS
    productList: null,
    originalEditedProduct: "",
    editedProduct: null,

    hasOverlays: true
  };

  componentDidMount = async () => {
    this.initialDataRender();
  };

  componentDidCatch = (error, info) => {
    console.log("This went in here");

    //COMPONENT ISSUE CHECK IF THIS ERROR HANDLING IS CORRECT
    this.setError(false, "componentDidCatch", error);
  };

  initialDataRender = async () => {
    this.setViewModel();
    await this.setPageData();
  };

  setError = (critical, methodName, error) => {
    this.props.log.error(error.message);
    if (critical) {
      this.setCriticalError();
    } else {
      this.setStandardError();
    }
    this.props.viewModel.createException(
      error,
      this.state.pageName,
      methodName
    );
  };
  setStandardError = () => {
    //MORE CAN BE ADDED HERE AS APPROPRIATE
    this.showError("Product");
    this.setState({ pageState: PageState.IDLE });
  };
  setCriticalError = () => {
    //SET ERROR STATE OF PAGE
    this.setState({ pageState: PageState.ERROR });
  };

  setViewModel = () => {
    try {
      this.props.viewModel.updateState = this.updateState;
      this.props.viewModel.showError = this.showError;
      this.props.viewModel.showSuccess = this.showSuccess;
      this.props.viewModel.showEmpty = this.showEmpty;
    } catch (error) {
      this.setError(false, "setViewModel", error);
    }
  };

  setPageData = async () => {
    try {
      this.setState({ pageState: PageState.LOADING });

      this.menuState(CrudlStatus.LIST);

      this.setUpColumns();

      // SPECIFIC API CALLS GO HERE
      await this.props.viewModel.getSubAssemblys();
      await this.props.viewModel.getParts();

      await this.props.viewModel.getProducts(
        this.state.partList,
        this.state.subAssemblyList
      );

      await this.props.viewModel.getAttributeSets();
      await this.props.viewModel.getSuppliers();

      await this.props.viewModel.getStations();

      this.props.viewModel.getStockOptions();
      this.props.viewModel.getOperationalTypeOptions();
      this.props.viewModel.getProductTypeOptions();

      //COMPONENT INFORMATION
      this.setUpComponentColumns();
      this.props.viewModel.getComponentList(
        this.state.partList,
        this.state.subAssemblyList
      );

      this.setState({
        pageState: PageState.IDLE
      });
    } catch (error) {
      this.setError(true, "setPageData", error);
    }
  };
  showError = (display, crudlStatus) => {
    try {
      this.props.feedback.showError(this.growl, display, crudlStatus);
    } catch (error) {
      this.setError(false, "showError", error);
    }
  };
  showSuccess = (display, crudlStatus) => {
    try {
      this.props.feedback.showSuccess(this.growl, display, crudlStatus);
    } catch (error) {
      this.setError(false, "showSuccess", error);
    }
  };
  showEmpty = display => {
    try {
      this.props.feedback.showEmpty(this.growl, display);
    } catch (error) {
      this.setError(false, "showEmpty", error);
    }
  };

  getStateValuesAsObject = () => {
    try {
      var externalObject = {};
      externalObject.productBean = this.state.editedProduct;

      return externalObject;
    } catch (error) {
      this.setError(false, "getStateValuesAsObject", error);
    }
  };

  updateBean = async (field, value) => {
    try {
      this.props.log.info(
        "Updating : [" + field + "] with value [" + value + "]"
      );
      await this.setState(prevState => ({
        editedProduct: {
          // object that we want to update
          ...prevState.editedProduct, // keep all other key-value pairs
          [field]: value
        }
      }));
    } catch (error) {
      this.setError(false, "updateBean", error);
    }
  };

  updateState = (key, value) => {
    try {
      this.setState({ [key]: value });
    } catch (error) {
      this.setError(false, "updateState", error);
    }
  };

  toggleOverlay = value => {
    try {
      this.props.log.info("Checking Overlays");
      if (this.state.hasOverlays) {
        this.props.log.info("Checking Overlays : true");
        if (format.isFunction(this.props.toggleTopbar)) {
          this.props.log.info("Checking Overlay Function : exists");
          this.props.toggleTopbar(value);
        }
      }
    } catch (error) {
      this.setError(false, "toggleOverlay", error);
    }
  };
  validateChanges = () => {
    try {
      if (this.state.editedProduct === null) {
        this.discardChanges();
      } else {
        if (
          format.isJsonEqual(
            this.state.originalEditedProduct,
            this.state.editedProduct
          )
        ) {
          this.discardChanges();
        } else {
          this.setState({ validateState: ValidateState.CONFIRM });
        }
      }
    } catch (error) {
      this.setError(false, "validateChanges", error);
    }
  };

  discardChanges = () => {
    try {
      this.setState({
        viewState: ViewState.TABLE,
        toggleChangesMade: false,
        crudlState: CrudlStatus.LIST,
        selectedProduct: null
      });
      this.toggleOverlay(ToggleState.ON);
      this.menuState(CrudlStatus.LIST);
    } catch (error) {
      this.setError(false, "discardChanges", error);
    }
  };

  checkRequiredFields = () => {
    try {
      if (format.isNotNull(this.state.editedProduct)) {
        // ADD REQUIREDD FIELDS HERE AS APPROPRIATE
        return format.validateValues([
          this.state.editedProduct.name,
          this.state.editedProduct.shortDescription
        ]);
      } else {
        return true;
      }
    } catch (error) {
      this.setError(false, "checkRequiredFields", error);
    }
  };

  menuState = crudlStatus => {
    try {
      this.setState({
        menuState: pr.getBreadcrumbMenuState(
          crudlStatus,
          "Product",
          "#/products"
        )
      });
    } catch (error) {
      this.setError(false, "menuState", error);
    }
  };

  executeCrudl = async stayOnPage => {
    try {
      if (format.isNotNull(this.state.crudlState)) {
        this.props.log.info(
          "Executing " +
            this.state.crudlState.value +
            " Staying [" +
            stayOnPage +
            "]"
        );

        switch (this.state.crudlState) {
          case CrudlStatus.CREATE:
            await this.addProduct(stayOnPage);
            break;
          case CrudlStatus.UPDATE:
            await this.updateProduct(stayOnPage);
            break;
          case CrudlStatus.DELETE:
            await this.deleteProduct();
            break;
          default:
            break;
        }
      }
    } catch (error) {
      this.setError(false, "executeCrudl", error);
    }
  };

  executeSetup = (requiredCrudlState, data) => {
    try {
      if (format.isNotNull(requiredCrudlState)) {
        this.props.log.info("Setting up " + requiredCrudlState.value);
        switch (requiredCrudlState) {
          case CrudlStatus.CREATE:
            this.createSetup();
            break;
          case CrudlStatus.UPDATE:
            this.updateSetup(data);
            break;
          case CrudlStatus.VIEW:
            this.viewSetup(data);
            break;
          case CrudlStatus.DELETE:
            this.deleteSetup(data);
            break;
          default:
            break;
        }
      }
    } catch (error) {
      this.setError(false, "executeSetup", error);
    }
  };

  setUpColumns = () => {
    let localCols = [];
    //SPECIFIC COLUMNS FOR TABLE
    localCols.push(pr.getTableColumn("name", "Name"));
    localCols.push(pr.getTableColumn("shortDescription", "Description"));
    localCols.push(pr.getTableColumn("operationalType", "Type"));

    this.setState({ tableColumns: localCols });
    var colOptions = pr.getColumnOptions(localCols);
    this.setState({ columnOptions: colOptions });
  };

  columnToggle = event => {
    this.setState({ tableColumns: event.value });
  };

  createSetup = () => {
    window.scrollTo(0, 0);

    var data = {};
    data = this.additionalParseFunctions(data, CrudlStatus.CREATE);

    this.setState({
      viewState: ViewState.CARD,
      crudlState: CrudlStatus.CREATE,
      editedProduct: data,
      originalEditedProduct: JSON.stringify(data)
    });
    this.toggleOverlay(ToggleState.OFF);
    this.menuState(CrudlStatus.CREATE);
  };

  updateSetup = data => {
    window.scrollTo(0, 0);

    data = this.additionalParseFunctions(data, CrudlStatus.UPDATE);

    this.setState({
      viewState: ViewState.CARD,
      crudlState: CrudlStatus.UPDATE,
      editedProduct: data,
      originalEditedProduct: JSON.stringify(data)
    });
    this.toggleOverlay(ToggleState.OFF);
    this.menuState(CrudlStatus.UPDATE);
  };

  viewSetup = data => {
    window.scrollTo(0, 0);

    data = this.additionalParseFunctions(data, CrudlStatus.VIEW);

    this.setState({
      viewState: ViewState.CARD,
      crudlState: CrudlStatus.VIEW,
      editedProduct: data,
      originalEditedProduct: JSON.stringify(data)
    });
    this.toggleOverlay(ToggleState.OFF);
    this.menuState(CrudlStatus.VIEW);
  };

  deleteSetup = data => {
    data = this.additionalParseFunctions(data, CrudlStatus.DELETE);

    this.setState({
      crudlState: CrudlStatus.DELETE,
      editedProduct: data,
      originalEditedProduct: JSON.stringify(data),
      validateState: ValidateState.DELETE
    });
    this.menuState(CrudlStatus.DELETE);
  };

  additionalParseFunctions = (data, crudlState) => {
    //TODO if required
    switch (crudlState) {
      case CrudlStatus.CREATE:
        data.operationalType = "SIMPLE";
        data.customPropertiesJson = "";
        data.imageUrls = [];
        data.selectedComponents = [];
        data.flowRequest = {};
        data.treeTableComponents = [];
        break;
      case CrudlStatus.UPDATE || CrudlStatus.VIEW:
        data = this.setAttributeSetandProperties(data);
        data = this.setComponentList(data);

        break;
      case CrudlStatus.DELETE:
        break;
      default:
        break;
    }
    this.props.log.info(data);
    return data;
  };

  addProduct = async stayOnPage => {
    this.setState({ pageState: PageState.LOADING });
    var stateVariables = this.getStateValuesAsObject();

    var productResponse = await this.props.viewModel.executeCRUDLAction(
      CrudlStatus.CREATE,
      stateVariables
    );

    if (productResponse.errorCode === 0) {
      if (!format.isNotNull(stayOnPage) || stayOnPage === false) {
        await this.updateProductList(
          productResponse,
          CrudlStatus.CREATE,
          stateVariables
        );
      } else {
        await this.updateCurrentProduct(
          productResponse,
          CrudlStatus.CREATE,
          stateVariables
        );
      }
    } else {
      this.setState({ pageState: PageState.IDLE });
    }
  };
  updateProduct = async stayOnPage => {
    this.setState({ pageState: PageState.LOADING });
    var stateVariables = this.getStateValuesAsObject();

    var productResponse = await this.props.viewModel.executeCRUDLAction(
      CrudlStatus.UPDATE,
      stateVariables
    );

    if (productResponse.errorCode === 0) {
      if (!format.isNotNull(stayOnPage) || stayOnPage === false) {
        await this.updateProductList(
          productResponse,
          CrudlStatus.CREATE,
          stateVariables
        );
      } else {
        await this.updateCurrentProduct(
          productResponse,
          CrudlStatus.CREATE,
          stateVariables
        );
      }
    } else {
      this.setState({ pageState: PageState.IDLE });
    }
  };

  deleteProduct = async () => {
    this.setState({ pageState: PageState.LOADING });
    var stateVariables = this.getStateValuesAsObject();

    var productResponse = await this.props.viewModel.executeCRUDLAction(
      CrudlStatus.DELETE,
      stateVariables
    );

    if (productResponse.errorCode === 0) {
      await this.updateProductList(
        productResponse,
        CrudlStatus.DELETE,
        stateVariables
      );
    } else {
      this.setState({ pageState: PageState.IDLE });
    }
  };

  updateProductList = async (apiResponse, type, stateVariables) => {
    this.setState({ pageState: PageState.LOADING });

    //TEMPORARY FIX HERE
    await this.setPageData();

    this.setState({
      viewState: ViewState.TABLE,
      crudlState: CrudlStatus.LIST,
      validateState: ValidateState.NONE,
      editedProduct: null
    });

    this.toggleOverlay(ToggleState.ON);
    this.menuState(CrudlStatus.LIST);

    this.setState({ pageState: PageState.IDLE });
  };

  updateCurrentProduct = async (apiResponse, type, stateVariables) => {
    this.setState({ pageState: PageState.LOADING });

    var productResponse = await this.props.viewModel.getProductAndFlow(
      this.state.partList,
      this.state.subAssemblyList,
      apiResponse.id
    );

    this.updateSetup(format.deepCopy(productResponse));
    this.setState({ pageState: PageState.IDLE });
  };

  updateAttributeProperties = (name, input) => {
    var attributePropertiesLocal = JSON.parse(
      this.state.editedProduct.customPropertiesJson
    );
    if (!format.isNotNull(attributePropertiesLocal)) {
      attributePropertiesLocal = {};
    }
    attributePropertiesLocal[name] = input;

    this.updateBean(
      "customPropertiesJson",
      JSON.stringify(attributePropertiesLocal)
    );
  };

  setAttributeSetandProperties = data => {
    if (format.isNotNull(this.state.attributeSetList)) {
      var attributePropertiesLocal = {};
      var selectedAtttribute = {};
      this.state.attributeSetList.forEach(element => {
        if (element.id === data.attributeSetId) {
          selectedAtttribute = format.deepCopy(element);
          if (!data.customPropertiesJson) {
            if (format.isNotNull(element.attributeBeanList)) {
              element.attributeBeanList.forEach(e => {
                attributePropertiesLocal[e.name] = "";
              });
              data.customPropertiesJson = JSON.stringify(
                attributePropertiesLocal
              );
            }
          }
        }
      });
      this.props.log.info(selectedAtttribute);
      this.updateState("selectedAttributeSet", selectedAtttribute);
      return data;
    }
  };

  selectAttributeSet = attributeSetId => {
    if (format.isNotNull(this.state.attributeSetList)) {
      var attributePropertiesLocal = {};
      var selectedAtttribute = {};
      this.state.attributeSetList.forEach(element => {
        if (element.id === attributeSetId) {
          selectedAtttribute = format.deepCopy(element);
          if (format.isNotNull(element.attributeBeanList)) {
            element.attributeBeanList.forEach(e => {
              attributePropertiesLocal[e.name] = "";
            });
          }
        }
      });
      this.props.log.info(selectedAtttribute);
      this.updateState("selectedAttributeSet", selectedAtttribute);
      this.updateBean(
        "customPropertiesJson",
        JSON.stringify(attributePropertiesLocal)
      );
    }
  };

  setComponentList = data => {
    var updatedData = format.deepCopy(data);
    var localPartList = format.deepCopy(data.selectedComponents);

    updatedData.treeTableComponents = this.convertListToTreeTable(
      this.state.componentList,
      localPartList
    );

    return updatedData;
  };
  setUpComponentColumns = () => {
    let localCols = [];
    //SPECIFIC COLUMNS FOR TABLE
    localCols.push(pr.getTableColumn("name", "Name"));
    localCols.push(pr.getTableColumn("shortDescription", "Description"));
    localCols.push(pr.getTableColumn("operationalType", "Type"));
    localCols.push(pr.getTableColumn("componentType", "Component"));

    this.setState({ componentColumns: localCols });
    var colOptions = pr.getColumnOptions(localCols);
    this.setState({ componentColumnOptions: colOptions });
  };

  hideComponentEditor = () => {
    var currentPartList = format.deepCopy(this.state.componentList);
    currentPartList.forEach(element => {
      delete element.quantityAdded;
      delete element.quantity;
    });
    this.setState({
      componentList: currentPartList,
      componentModalView: false
    });
  };

  updateComponentSelected = (f, bean) => {
    f.preventDefault();

    var localBean = bean;
    var localPartList = format.deepCopy(
      this.state.editedProduct.selectedComponents
    );

    var pojo = format.parsePojoRow(localBean.id, localBean.quantity);
    var elementFound = false;
    localPartList.forEach(element => {
      if (element.id === localBean.id) {
        elementFound = true;
        element.quantity = (
          parseInt(element.quantity, 10) + parseInt(localBean.quantity, 10)
        ).toString();
      }
    });
    if (elementFound === false) {
      localPartList.push(localBean);
    }

    var currentPartList = format.deepCopy(this.state.componentList);
    currentPartList.forEach(element => {
      if (element.id === localBean.id) {
        element.quantityAdded = true;
      }
    });
    this.setState({
      componentList: currentPartList
    });
    this.updateBean(
      "treeTableComponents",
      this.convertListToTreeTable(this.state.componentList, localPartList)
    );
    this.updateBean("selectedComponents", localPartList);
  };
  removeComponent = bean => {
    var localPartList = format.deepCopy(
      this.state.editedProduct.selectedComponents
    );
    var updatedLocalPartList = [];
    localPartList.forEach(element => {
      if (element.id === bean.id) {
      } else {
        updatedLocalPartList.push(element);
      }
    });
    this.updateBean(
      "treeTableComponents",
      this.convertListToTreeTable(
        this.state.componentList,
        updatedLocalPartList
      )
    );
    this.updateBean("selectedComponents", updatedLocalPartList);
  };

  convertListToTreeTable = (fullComponentList, selectedComponentList) => {
    var componentTreeList = [];
    var index = 0;
    if (format.isNotNull(selectedComponentList)) {
      selectedComponentList.forEach(element => {
        var treeRow = {};
        treeRow.key = index.toString();
        treeRow.data = format.deepCopy(element);

        if (element.componentType === "PART") {
          treeRow.children = [];
        }
        if (element.componentType === "SUB-ASSEMBLY") {
          var children = [];
          var localIndex = 0;

          if (format.isNotNull(element.partProductJson)) {
            var partProduct = JSON.parse(element.partProductJson);
            if (format.isNotNull(partProduct.parts)) {
              partProduct.parts.forEach(part => {
                fullComponentList.forEach(component => {
                  if (part.id === component.id) {
                    var treeRow = {};
                    treeRow.key =
                      "child" + component.Id + localIndex.toString();
                    treeRow.data = format.deepCopy(component);
                    treeRow.children = [];
                    children.push(treeRow);
                    localIndex++;
                  }
                });
              });
            }
            if (format.isNotNull(partProduct.products)) {
              partProduct.products.forEach(sub => {
                fullComponentList.forEach(component => {
                  if (sub.id === component.id) {
                    var treeRow = this.parseSubAssemblyTreeView(
                      component,
                      localIndex,
                      fullComponentList
                    );
                    children.push(treeRow);
                    localIndex++;
                  }
                });
              });
            }
          }

          treeRow.children = children;
        }

        componentTreeList.push(treeRow);
        index++;
      });
    }
    return componentTreeList;
  };

  parseSubAssemblyTreeView = (component, index, fullComponentList) => {
    var treeRow = {};

    treeRow.key = "child" + component.Id + index.toString();
    treeRow.data = format.deepCopy(component);
    var children = [];

    var localIndex = 0;
    if (format.isNotNull(component.partProductJson)) {
      var partProduct = JSON.parse(component.partProductJson);
      if (format.isNotNull(partProduct.parts)) {
        partProduct.parts.forEach(part => {
          fullComponentList.forEach(component => {
            if (part.id === component.id) {
              var treeRow = {};
              treeRow.key = "child" + component.Id + localIndex.toString();
              treeRow.data = format.deepCopy(component);
              treeRow.children = [];
              children.push(treeRow);
              localIndex++;
            }
          });
        });
      }
      if (format.isNotNull(partProduct.products)) {
        partProduct.products.forEach(sub => {
          fullComponentList.forEach(component => {
            if (sub.id === component.id) {
              var treeRow = this.parseSubAssemblyTreeView(
                component,
                localIndex,
                fullComponentList
              );
              children.push(treeRow);
              localIndex++;
            }
          });
        });
      }
    }
    treeRow.children = children;
    return treeRow;
  };
  render() {
    return (
      <React.Fragment>
        <pr.Growl style={{ textAlign: "left" }} ref={el => (this.growl = el)} />

        {/*VERY VERY BAD ERROS ONLY eg PAGE LOAD*/}
        {this.state.pageState === PageState.ERROR && (
          <ErrorScreen
            loading={this.state.pageState === PageState.LOADING}
            refresh={this.setPageData}
          />
        )}

        {this.state.pageState !== PageState.ERROR && (
          <ProductView
            //STATE + HELPER VALUES
            viewState={this.state.viewState}
            validateState={this.state.validateState}
            crudlState={this.state.crudlState}
            menuState={this.state.menuState}
            loading={this.state.pageState === PageState.LOADING}
            updateState={this.updateState}
            refresh={this.setPageData}
            //CARD SPECIFIC PROPS
            editedObject={this.state.editedProduct}
            productTypeOptions={this.state.productTypeOptions}
            updateEdited={this.updateBean}
            validateChanges={this.validateChanges}
            discardChanges={this.discardChanges}
            checkRequiredFields={this.checkRequiredFields}
            crudlExecute={this.executeCrudl}
            stockTypeOptions={this.state.stockTypeOptions}
            operationalTypeOptions={this.state.operationalTypeOptions}
            attributeSetMap={this.state.attributeSetMap}
            supplierMap={this.state.supplierMap}
            stationMap={this.state.stationMap}
            selectAttributeSet={this.selectAttributeSet}
            updateAttributeProperties={this.updateAttributeProperties}
            selectedAttributeSet={this.state.selectedAttributeSet}
            componentColumns={this.state.componentColumns}
            componentList={this.state.componentList}
            componentModalView={this.state.componentModalView}
            hideComponentEditor={this.hideComponentEditor}
            updateComponentSelected={this.updateComponentSelected}
            removeComponent={this.removeComponent}
            componentExpandedRows={this.state.componentExpandedRows}
            //TABLE SPECIFIC PROPS
            crudlControl={this.executeSetup}
            productList={this.state.productList}
            expandedRows={this.state.expandedRows}
            tableColumns={this.state.tableColumns}
            columnOptions={this.state.columnOptions}
            columnToggle={this.columnToggle}
            tableReference={this.state.tableReference}
            rowCount={this.state.rowCount}
            settingsToggle={this.state.settingsToggle}
          />
        )}
      </React.Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Products/ProductController.js